import { Component, OnInit } from "@angular/core";
import { Compiler, NgZone } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ProfileDataService, SeedDataService } from "../../Services/index";

import {
  SelectItem,
  DataTableModule,
  ButtonModule,
  DialogModule,
  InputTextModule,
  MessagesModule,
  Message,
  CalendarModule,
  FieldsetModule,
  InputTextareaModule,
  FileUploadModule,
  ConfirmationService,
  BlockUIModule,
} from "primeng/primeng";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { environment } from "../../../environments/environment";
import * as jQuery from "jquery";

//import { teamMemberProfile } from 'Models/profile.model';
(window as any).jQuery = (window as any).$ = jQuery;
@Component({
  // moduleId: "module.id",
  templateUrl: "./Profile.html",
})
export class ProfileComponent implements OnInit {
  workLocation: SelectItem[];
  public profileDetails: any;
  public detail: any;
  disabled: boolean = true;
  editProfileDialog: boolean = false;
  errorMsgs: Message[] = [];
  UserId: string;
  userImg: string;
  bloodGroup: SelectItem[];
  hobbieslist: SelectItem[];
  passingYear: SelectItem[];
  zodiacSign: SelectItem[];
  Validplace: boolean;
  ValidDependentName: boolean;
  ValidDependentDateOfBirth: boolean;
  ValidDate: boolean;
  ValidDatePassport: boolean;
  ValidVaccineFirstDFose: boolean;
  ValidVaccinationStatus: boolean;
  ValidVaccinationNameReq: boolean;
  ValidSecondCertificateUploaded: boolean;
  ValidFirstCertificateUploaded: boolean;
  ValidVaccineSecondtDFose: boolean;
  ValidDatePassportReq: boolean;
  ValidDatePassportReqerror: boolean;
  ValidPassportNofield: boolean;
  IsErrorMessageforVisa: boolean;
  IsErrorMessageforDuplicateVisa: boolean;
  ValidDOB: boolean;
  ValidPersonalEmailID: boolean;
  ValidMobileNumber: boolean;
  ValidboardOrUniversityName: boolean;
  ValidSpecializationName: boolean;
  ValidboardName10th: boolean;
  ValidschoolOrCollegeName: boolean;
  ValidPANNo: boolean;
  HasFirstCertificateUploaded: boolean;
  HasSecondCertificateUploaded: boolean;
  showPreviewButtonFirstCertificate: boolean = false;
  showPreviewButtonSecondCertificate: boolean = false;
  ValidHobbies: boolean;
  ValidPreviousCompanyName: boolean;
  ValidschoolOrCollegeName12th: boolean;
  ValidJobTitleName: boolean;
  PageIsvalid: boolean;
  msgs: Message[] = [];
  userform: FormGroup;
  submitted: boolean = false;
  cdob: string;
  dependentRelationships: SelectItem[];
  public experinceDetails: any;
  public dependentDetails: any;
  public travelInfoDetails: any;
  public passportVisaInfoDetails: any;
  Validpercentage10th: boolean;
  DeleteProfileImage: boolean;
  dataSources: SelectItem[];
  selectedDataSource: string;
  ValidAnniversaryDate: boolean;
  ValidEmergencyMobileNumber: boolean;
  ValidAdharNumber: boolean;
  uploadedFiles: any[] = [];
  uploadedUploadFiles: any[] = [];
  maritalStatusList: any = null;
  SingleMaritalStatusName = "";
  SingleMaritalStatusID = "";
  DisableAnniversaryDate = false;
  DisableCelebratedDateOfBirth = false;
  ValidpostGraduationPercentage: boolean;
  ValidgraduationPercentage: boolean;
  Validpercentage12th: boolean;
  DisabledPassportExpiryDate: boolean;
  DisableVisaExpiryDate: boolean;
  minDatesecond: Date;
  datenegativetested: Date;
  maxDate: Date;
  DisableUAN = false;
  DisableESIC = false;
  DisableadharNumber = false;

  PageIsvalidSpecialization1Oth: boolean;
  PageIsvalidpercentage12th: boolean;
  PageIsvalidpostGraduationPercentage: boolean;
  PageIsvalidgraduationPercentage: boolean;
  loading: boolean = false;
  refdate: any;
  dateTimetoday: any;
  Specialization1Oth: any = [];
  Specialization12th: any = [];
  SpecializationGradution: any = [];
  SpecializationPostGradution: any = [];
  minDate: any;
  //Specialization12th.boardOrUniversityName: any;
  currentDate: any;
  ValidPassingYear10th: boolean = true;
  ValidPassingYearEqualBirth10th: boolean = true;
  expToIsValid: false;
  expFromIsValid: false;
  ValidWorkexpFromDate: boolean = true;
  ValidWorkexpToDate: boolean = true;
  experienceFromDate: Date;
  experienceToDate: Date;
  experienceIsValid: boolean = true;
  selectedId: number;
  dateValidation: boolean = true;
  shown: boolean;
  visaCountry: SelectItem[];

  vaccinationStatusLOV: SelectItem[];
  vaccineTypeLOV: SelectItem[];
  AntibodyTestStatus: SelectItem[];
  FamilyStatus: SelectItem[];
  InfectionRecoveryDetails: SelectItem[];
  TypeTreatment: SelectItem[];
  noDoseLOVID: any;
  firstDoseLOVID: any;
  Antibodyoptionone: any;
  Antibodyoptiontwo: any;
  InfectionStatusoptionone: any;
  InfectionStatusoptiontwo: any;
  InfectionStatusoptionthree: any;
  TypeOfTreatmenthospitalised: any;
  TypeOfTreatmentquarintine: any;
  TypeOfTreatmentooutpatient: any;
  TypeOfTreatmentnonapplicable: any;
  secondDoseLOVID: any;
  boosterDose: any;
  VaccinationDetail: any = [];

  isfirstdose: boolean = false;
  isSeconddose: boolean = false;
  isBoosterdose: boolean = false;
  AntibodyCheckStatus: boolean = false;
  Activetypetreatment: boolean = false;
  isHospitalised: boolean = false;

  // ValidVaccinationBeneficiaryRef: boolean;
  // ValidVaccinationUniqueID: boolean;
  // Validfirstdosevenue: boolean;
  // ValidAntibodyLevel: boolean;
  // Validseconddosevenue: boolean;
  // ValidantibodyTestDate: boolean;
  // Validboosterdosevenue: boolean;
  // ValidAntibodyTestVenue: boolean;
  // Validboosterdosedate: boolean;
  // ValidInfectionRecoveryDetails: boolean;
  // Validfamilystatus: boolean;
  // ValidtreatmentType: boolean;
  // ValidAntibodyTestStatus: boolean;
  // ValiddatePositiveTested: boolean;
  // ValiddateNegativeTested: boolean;
  // ValiddhospitalisationDuration: boolean;
  // ValidhospitalisationVenue: boolean;
  // isVaccinationFormValid: boolean;
  // isformvalid: boolean;
  private readonly APIEndPoint: string = environment.apiEndPoint;
  private imgFile: any;

  constructor(
    private profiledataservice: ProfileDataService,
    private seedDataService: SeedDataService,
    private fb: FormBuilder,
    private _compiler: Compiler,
    private zone: NgZone,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    //this.Specialization12th.boardOrUniversityName: any = null;
    this._compiler.clearCache();
    this.profileDetails = [];
    this.userImg = "../../../UserPhoto/male.png";
    //this.dependentImg = '../../../Dependent/male.png';
    // this.Specialization1Oth = [];
    // this.Specialization12th = [];
    // this.SpecializationGradution = [];
    // this.SpecializationPostGradution = [];
    this.refdate = "?" + new Date();
    this.dateTimetoday = new Date();
  }

  onUserPhotoUpload(event: any) {
    if (event.files.length > 1) {
    }
    for (let file of event.files) {
      console.log(file);
      this.uploadedUploadFiles.push(file);
      //this.profiledataservice.SaveUserPhoto(this.profileDetails.userID, file.name).subscribe((data) => {
      //});
    }
    this.GetUserPhotoUrl(this.profileDetails.userID);
    this.msgs = [];
    this.msgs.push({ severity: "info", summary: "Image Uploaded", detail: "" });
  }
  download() {}
  OnuploadFirstDoseCertificate(event: any) {
    if (event.files.length == 1) {
      this.HasFirstCertificateUploaded = true;
      this.ValidFirstCertificateUploaded = true;
      this.showPreviewButtonFirstCertificate = true;
    }
  }
  OnuploadSecondDoseCertificate(event: any) {
    if (event.files.length == 1) {
      this.HasSecondCertificateUploaded = true;
      this.ValidSecondCertificateUploaded = true;
      this.showPreviewButtonSecondCertificate = true;
    }
  }

  checkValue(event: any) {
    this.profiledataservice
      .SaveProfileImageConsent(event, this.profileDetails.userID)
      .subscribe((data) => {});
  }
  GetUserPhotoUrl(userid: any) {
    this.profiledataservice.GetUserPhoto(userid).subscribe((data1) => {
      this.userImg = "../../../" + data1 + "?" + new Date();
      if (data1.indexOf("male.png") > -1) {
        this.DeleteProfileImage = false;
      } else {
        this.DeleteProfileImage = true;
      }
    });
  }

  onDependentPhotoUpload(event: any, dependentImg: any) {
    for (let file of event.files) {
      this.uploadedUploadFiles.push(file);
    }
    //this.profiledataservice.GetDependentPhoto(this.profileDetails.userID).subscribe(data1 => {
    //        //dependent.dependentImg = '../../../' + this.profileDetails.userID + "_" + file.name + "?" + (new Date());
    //    });
    this.msgs = [];
    this.msgs.push({ severity: "info", summary: "Image Uploaded", detail: "" });
    this.refdate = "?" + new Date();
  }

  onPassportVisaPhotoUpload(event: any, pvImg: any) {
    // alert(pvImg)
    for (let file of event.files) {
      this.uploadedUploadFiles.push(file);
    }

    this.msgs = [];
    this.msgs.push({ severity: "info", summary: "Image Uploaded", detail: "" });
    this.refdate = "?" + new Date();
  }

  ngOnInit() {
    this.shown = false;
    // this.DisabledPassportExpiryDate= true;
    // this.DisableVisaExpiryDate=true;
    this.ResetFormValidations();
    this.seedDataService
      .getLOVByTypeName("BloodGroup")
      .subscribe((bloodGroup: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(bloodGroup),
          "Select Blood Group"
        );
        this.bloodGroup = data;
      });
    this.seedDataService
      .getLOVByTypeName("MaritalStatus")
      .subscribe((maritalStatuslist: SelectItem[]) => {
        console.log("-----------", maritalStatuslist);
      });
    this.seedDataService
      .getLOVByTypeName("ZodiacSigns")
      .subscribe((zodiacSign: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(zodiacSign),
          "Select Zodiac Sign"
        );
        this.zodiacSign = data;
      });
    this.seedDataService
      .getLOVByTypeName("Hobbies")
      .subscribe((hobbieslist: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(hobbieslist),
          "Select Hobbies"
        );

        this.hobbieslist = data;
      });
    this.seedDataService
      .getLOVByTypeName("PassingYear")
      .subscribe((passingYear: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(passingYear),
          "Select Passing Year"
        );
        this.passingYear = data;
      });

    // this.seedDataService
    //   .getLOVByTypeName("Vaccination Status")
    //   .subscribe((vaccinationStatusLOV: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(vaccinationStatusLOV),
    //       "Select Vaccination Status"
    //     );

    //     this.noDoseLOVID = data.filter((obj) => {
    //       return obj.label === "Not Vaccinated";
    //     })[0].value;
    //     this.firstDoseLOVID = data.filter((obj) => {
    //       return obj.label === "1st Dose Vaccinated";
    //     })[0].value;
    //     this.secondDoseLOVID = data.filter((obj) => {
    //       return obj.label === "2nd Dose Vaccinated";
    //     })[0].value;
    //     this.boosterDose = data.filter((obj) => {
    //       return obj.label === "Fully Vaccinated and Booster Administered";
    //     })[0].value;

    //     this.vaccinationStatusLOV = data;
    //   });

    // this.seedDataService
    //   .getLOVByTypeName("Vaccine Type")
    //   .subscribe((vaccineNameLOV: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(vaccineNameLOV),
    //       "Select Vaccine Name"
    //     );
    //     this.vaccineTypeLOV = data;
    //   });

    // this.seedDataService
    //   .getLOVByTypeName("Vaccination Status of the Family")
    //   .subscribe((FamilyStatusLOV: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(FamilyStatusLOV),
    //       "Choose Status"
    //     );
    //     this.FamilyStatus = data;
    //   });

    // this.seedDataService
    //   .getLOVByTypeName("Antibody Test Status")
    //   .subscribe((AntibodyTestStatusLov: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(AntibodyTestStatusLov),
    //       "Choose Status"
    //     );
    //     this.Antibodyoptionone = data.filter((obj) => {
    //       return obj.label === "I have tested and and have the details with me";
    //     })[0].value;
    //     this.Antibodyoptiontwo = data.filter((obj) => {
    //       return (
    //         obj.label === "I haven't tested or I don't have the details with me"
    //       );
    //     })[0].value;
    //     this.AntibodyTestStatus = data;
    //   });

    // this.seedDataService
    //   .getLOVByTypeName("Infection and Recovery Details")
    //   .subscribe((InfectionRecoveryDetailsLov: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(InfectionRecoveryDetailsLov),
    //       "Choose Status"
    //     );
    //     this.InfectionStatusoptionone = data.filter((obj) => {
    //       return (
    //         obj.label === "I was tested postive and I have recovered eventually"
    //       );
    //     })[0].value;
    //     this.InfectionStatusoptiontwo = data.filter((obj) => {
    //       return (
    //         obj.label === "I was never tested positive but I had few symptoms"
    //       );
    //     })[0].value;
    //     this.InfectionStatusoptionthree = data.filter((obj) => {
    //       return (
    //         obj.label ===
    //         "I was never tested positive and I never had any symptoms"
    //       );
    //     })[0].value;
    //     this.InfectionRecoveryDetails = data;
    //   });

    // this.seedDataService
    //   .getLOVByTypeName("Type of Treatment")
    //   .subscribe((TypeTreatmentLov: SelectItem[]) => {
    //     let data = this.renamePropertyNames(
    //       JSON.stringify(TypeTreatmentLov),
    //       "Choose Status"
    //     );
    //     this.TypeOfTreatmenthospitalised = data.filter((obj) => {
    //       return obj.label === "I was hospitalised";
    //     })[0].value;
    //     this.TypeOfTreatmentooutpatient = data.filter((obj) => {
    //       return obj.label === "I was an outpatient";
    //     })[0].value;
    //     this.TypeOfTreatmentnonapplicable = data.filter((obj) => {
    //       return obj.label === "Not applicable";
    //     })[0].value;
    //     this.TypeOfTreatmentquarintine = data.filter((obj) => {
    //       return obj.label === "I was home quarantined";
    //     })[0].value;
    //     this.TypeTreatment = data;
    //   });

    if (
      this.route.snapshot.params["UserId"] != null &&
      this.route.snapshot.params["UserId"] != 0
    ) {
      this.UserId = this.route.snapshot.params["UserId"];
    } else {
      var role = JSON.parse(window.localStorage.getItem("currentUser"));
      this.UserId = role.UserId;
    }

    this.GetUserPhotoUrl(this.UserId);

    this.profiledataservice
      .GetTeamMemberProfile(this.UserId)
      .subscribe((profile: any) => {
        
        this.profileDetails = profile;
        if (this.profileDetails.passportNumber != "") {
          this.ValidDatePassportReq = false;
        }
        if (
          this.profileDetails != null &&
          this.profileDetails.celebratedDateOfBirth != null &&
          this.profileDetails.celebratedDateOfBirth != ""
        ) {
          this.DisableCelebratedDateOfBirth = true;
        }
        if (
          this.profileDetails != null &&
          this.profileDetails.uanNumber != null &&
          this.profileDetails.uanNumber != ""
        ) {
          this.DisableUAN = true;
        }
        if (
          this.profileDetails != null &&
          this.profileDetails.esic != null &&
          this.profileDetails.esic != ""
        ) {
          this.DisableESIC = true;
        }
        if (
          this.profileDetails != null &&
          this.profileDetails.adharNumber != null &&
          this.profileDetails.adharNumber != ""
        ) {
          this.DisableadharNumber = true;
        }
        if (
          this.profileDetails != null &&
          this.profileDetails.anniversaryDate != null &&
          this.profileDetails.anniversaryDate != ""
        ) {
         
          this.DisableAnniversaryDate = true;
        }

        if (this.profileDetails) {
          this.EnablePassportExpiryDate(this.profileDetails.passportNumber);
          this.EnableVisaExpiryDate(this.profileDetails.visaStatus);
        }

       
        this.seedDataService
          .getLOVByTypeName("MaritalStatus")
          .subscribe((maritaStatusList) => {
            this.maritalStatusList = maritaStatusList;
            this.seedDataService
              .GetKeyValue("SingleMaritalStatus")
              .subscribe((name) => {
                this.SingleMaritalStatusName = name;
                let tempStatusName = this.SingleMaritalStatusName;
                let filteredList = this.maritalStatusList.filter(function (
                  elem: any
                ) {
                  return (
                    elem.name.trim().toUpperCase() ==
                    tempStatusName.trim().toUpperCase()
                  );
                });
                if (filteredList != null && filteredList.length > 0) {
                  this.SingleMaritalStatusID = filteredList[0].id;
                }
                if (
                  this.SingleMaritalStatusID ==
                    this.profileDetails.maritalStatus ||
                  (this.profileDetails != null &&
                    this.profileDetails.anniversaryDate != null &&
                    this.profileDetails.anniversaryDate != "")
                ) {
                  
                  this.DisableAnniversaryDate = true;
                } else {
                 
                  this.DisableAnniversaryDate = false;
                }
              });
          });
        if (
          this.profileDetails.dateofJoining != null &&
          this.profileDetails.dateofJoining != ""
        ) {
          this.maxDate = new Date(this.profileDetails.dateofJoining.toString());
        } else {
          this.maxDate = new Date();
        }
        this.minDate = new Date(1950, 1, 1);
      });

    this.seedDataService
      .getLOVByTypeName("Location")
      .subscribe((yearslist: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(yearslist),
          "Select Location"
        );
        this.workLocation = data;
      });
    this.seedDataService
      .getLOVByTypeName("DependentRelationship")
      .subscribe((dependentRelationships: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(dependentRelationships),
          "Select Relationship"
        );
        this.dependentRelationships = data;
      });

    this.seedDataService
      .getLOVByTypeName("TravelCountryVisited")
      .subscribe((visaCountry: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(visaCountry),
          "Select Country"
        );
        this.visaCountry = data;
      });
    setTimeout(() => {
      if (this.route.snapshot.params["Id"] != null) {
        this.toggleEditDialog();
      }
    }, 1000);
  }

  ResetFormValidations() {
    this.PageIsvalid = true;
    this.ValidPersonalEmailID = true;
    this.ValidPANNo = true;
    this.ValidHobbies = true;
    this.ValidMobileNumber = true;
    this.ValidboardOrUniversityName = true;
    this.ValidSpecializationName = true;
    this.ValidboardName10th = true;
    this.ValidEmergencyMobileNumber = true;
    this.ValidAdharNumber = true;
    this.ValidDate = true;
    this.ValidDatePassport = true;
    // this.ValidVaccineFirstDFose = true;
    // this.ValidVaccinationStatus = true;
    // this.ValidVaccinationNameReq = true;
    // this.ValidSecondCertificateUploaded = true;
    // this.ValidFirstCertificateUploaded = true;
    // this.ValidVaccineSecondtDFose = true;
    this.ValidPassportNofield = true;
    this.IsErrorMessageforVisa = false;
    this.IsErrorMessageforDuplicateVisa = false;
    this.ValidDOB = true;
    this.ValidAnniversaryDate = true;
    this.ValidDatePassportReq = true;
    this.ValidDatePassportReqerror = true;
    this.ValidDependentName = true;
    this.ValidDependentDateOfBirth = true;
    this.ValidschoolOrCollegeName = true;
    this.Validplace = true;
    this.ValidPreviousCompanyName = true;
    this.ValidJobTitleName = true;
    this.ValidschoolOrCollegeName12th = true;
    this.Validpercentage10th = true;
    this.ValidgraduationPercentage = true;
    this.ValidpostGraduationPercentage = true;
    this.Validpercentage12th = true;
    this.PageIsvalidSpecialization1Oth = true;
    this.PageIsvalidpercentage12th = true;
    this.PageIsvalidpostGraduationPercentage = true;
    this.PageIsvalidgraduationPercentage = true;

    // this.ValidVaccinationBeneficiaryRef = true;
    // this.Validfirstdosevenue = true;
    // this.ValidVaccinationUniqueID = true;
    // this.Validseconddosevenue = true;
    // this.Validboosterdosevenue = true;
    // this.Validboosterdosedate = true;
    // this.Validfamilystatus = true;
    // this.ValidAntibodyTestStatus = true;
    // this.ValidAntibodyLevel = true;
    // this.ValidantibodyTestDate = true;
    // this.ValidAntibodyTestVenue = true;
    // this.ValidInfectionRecoveryDetails = true;
    // this.ValidtreatmentType = true;
    // this.ValiddatePositiveTested = true;
    // this.ValiddateNegativeTested = true;
    // this.ValiddhospitalisationDuration = true;
    // this.ValidhospitalisationVenue = true;

    // this.ValidVisaExpiryDate = true;
    // this.ValidPassportExpiryDate = true;

    this.userform = this.fb.group({
      mobile: ["", Validators.required],
      pan: ["", Validators.required],
      address: ["", Validators.required],
      fatherName: ["", Validators.required],
      motherName: ["", Validators.required],
      celebratedDateOfBirth: ["", Validators.required],
      passportNumber: [""],
      visaStatus: [""],
      hobbies: [""],
      //'dependentName': [''],
      //'dependentDateOfBirth': [''],
      passportExpiryDate: [""],
      visaExpiryDate: [""],
      dependentRelationship: [""],
      bloodGroup: [""],
      anniversaryDate: [""],
      zodiacSign: [""],
      alternateEmailId: [""],
      emergencyContactNumber: [""],
      specialization12th: [""],
      boardName12th: [""],
      nameofSchool12th: [""],
      placeofeducation12th: [""],
      percentage12th: [""],
      yearofPassing12th: [""],
      boardName10th: [""],
      nameofSchool10th: [""],
      placeofeducation10th: [""],
      percentage10th: [""],
      yearofPassing10th: [""],
      graduationNameoftheCollege: [""],
      graduationUniversityName: [""],
      graduationPercentage: [""],
      graduationPlaceofeducation: [""],
      graduationYearofPassing: [""],
      postGraduationNameoftheCollege: [""],
      postGraduationUniversityName: [""],
      postGraduationPercentage: [""],
      postGraduationPlaceofeducation: [""],
      postGraduationCourse: [""],
      graduationCourse: [""],
      postGraduationYearofPassing: [""],
      pfNumber: [""],
      uanNumber: [""],
      adharNumber: [""],
      esic: [""],
      salaryAccountNumber: [""],
      extension: [""],
      aboutYou: [""],
      preferredName: [""],
      permanentAddress: [""],
      isPublishMobileNumber: [""],
      isPublishDOB: [""],
      isPublishMarriageAnniversary: [""],
      isPublishAddress: [""],
      isPublishWorkAnniversary: [""],
      uploadDocument: [""],
      uploadDocumentUri: [""],
      visaCountry: [""],

      // vaccinationStatus: ["", Validators.required],
      // vaccineName: ["", Validators.required],
      // firstDoseDate: ["", Validators.required],
      // firstDoseDoc: ["", Validators.required],
      //  secondDoseDate:["", Validators.required],
      // secondDoseDate: [""],
      // BeneficiaryRefID: [""],
      // UniqueHealthID: [""],
      // BoosterDate: [""],
      // AntibodyTestStatus: [""],
      // BoosterDoseVenue: [""],
      // AntibodyLevel: [""],
      // DatePositiveTested: [""],
      // TypeTreatment: [""],
      // HospitlisationVenue: [""],
      // HospitalisationDays: [""],
      // InfectionRecoveryDetails: [""],
      // DateNegativeTested: [""],
      // AntibodyTestDate: [""],
      // AntibodyTestVenue: [""],
      // firstDoseVenue: [""],
      // FamilyStatus: [""],
      // SecondDoseVenue: [""],
      // SecondDoseCertificatePath: [""],
      // secondDoseDoc: [""],
    });
  }

  OnFutureDateSelect() {
    var currentDate = new Date();
    var selectedstartMinutes = new Date(
      this.profileDetails.anniversaryDate
    ).getMinutes();
    var selectedstartHours = new Date(
      this.profileDetails.anniversaryDate
    ).getHours();
    var selectedstartDate = new Date(
      this.profileDetails.anniversaryDate
    ).getDate();
    var selectedstartMonth = new Date(
      this.profileDetails.anniversaryDate
    ).getMonth();
    var selectedstartYear = new Date(
      this.profileDetails.anniversaryDate
    ).getFullYear();
    var newSelectedCurrentDate = new Date(
      selectedstartYear,
      selectedstartMonth,
      selectedstartDate,
      selectedstartHours,
      selectedstartMinutes
    );
    if (newSelectedCurrentDate >= currentDate) {
      this.ValidAnniversaryDate = false;
      this.PageIsvalid = false;
      // alert(newSelectedCurrentDate);
      //alert(currentDate);
    } else {
      this.ValidAnniversaryDate = true;
      this.PageIsvalid = true;
    }
  }
  // VaccineStatusSelected() {
  //   this.toggleFields();
  // }
  // toggleFields() {
  //   if (this.VaccinationDetail.vaccinationStatus != 0) {
  //     this.ValidVaccinationStatus = true;
  //   }
  //   if (this.VaccinationDetail.vaccinationStatus === this.firstDoseLOVID) {
  //     this.isfirstdose = true;
  //     this.isSeconddose = false;
  //     this.isBoosterdose = false;
  //     this.isDisabled(false, 1);
  //     this.VaccinationDetail.secondDoseDatev = "";
  //     this.VaccinationDetail.secondDoseVenue = "";
  //     this.VaccinationDetail.boosterDoseDate = "";
  //     this.VaccinationDetail.boosterDoseVenue = "";
  //   }
  //   if (
  //     this.VaccinationDetail.vaccinationStatus === this.noDoseLOVID ||
  //     this.VaccinationDetail.vaccinationStatus == ""
  //   ) {
  //     this.isfirstdose = false;
  //     this.isSeconddose = false;
  //     this.isBoosterdose = false;
  //     this.isDisabled(true, 0);
  //     this.VaccinationDetail.vaccineID = 0;
  //     this.VaccinationDetail.beneficiaryReferenceID = "";
  //     this.VaccinationDetail.uniqueHealthID = "";
  //     this.VaccinationDetail.firstDoseDatev = "";
  //     this.VaccinationDetail.firstDoseVenue = "";
  //     this.VaccinationDetail.secondDoseDatev = "";
  //     this.VaccinationDetail.secondDoseVenue = "";
  //     this.VaccinationDetail.boosterDoseDate = "";
  //     this.VaccinationDetail.boosterDoseVenue = "";
  //   }
  //   if (this.VaccinationDetail.vaccinationStatus === this.secondDoseLOVID) {
  //     this.isSeconddose = true;
  //     this.isBoosterdose = false;
  //     this.isfirstdose = false;
  //     this.isDisabled(false, 2);
  //     this.VaccinationDetail.boosterDoseDate = "";
  //     this.VaccinationDetail.boosterDoseVenue = "";
  //   }
  //   if (this.VaccinationDetail.vaccinationStatus === this.boosterDose) {
  //     this.isBoosterdose = true;
  //     this.isDisabled(false, 3);
  //   }
  // }
  // VaccineNameSelected() {
  //   if (this.VaccinationDetail.vaccineID != 0) {
  //     this.ValidVaccinationNameReq = true;
  //     //   this.PageIsvalid = true;
  //   }
  // }
  // isDisabled(value: boolean, dose: number) {
  //   if (value) {
  //     this.userform.controls["BeneficiaryRefID"].disable();
  //     this.userform.controls["UniqueHealthID"].disable();
  //     this.userform.controls["firstDoseVenue"].disable();
  //     this.userform.controls["SecondDoseVenue"].disable();
  //     this.userform.controls["BoosterDoseVenue"].disable();
  //   } else {
  //     this.userform.controls["BeneficiaryRefID"].enable();
  //     this.userform.controls["UniqueHealthID"].enable();
  //     if (dose === 1) {
  //       this.userform.controls["firstDoseVenue"].enable();
  //       this.userform.controls["SecondDoseVenue"].disable();
  //       this.userform.controls["BoosterDoseVenue"].disable();
  //     }
  //     if (dose === 2) {
  //       this.userform.controls["firstDoseVenue"].enable();
  //       this.userform.controls["SecondDoseVenue"].enable();
  //       this.userform.controls["BoosterDoseVenue"].disable();
  //     }
  //     if (dose === 3) {
  //       this.userform.controls["firstDoseVenue"].enable();
  //       this.userform.controls["SecondDoseVenue"].enable();
  //       this.userform.controls["BoosterDoseVenue"].enable();
  //     }
  //   }
  // }
  // firstDoseSelected() {
  //   if (this.VaccinationDetail.firstDoseSelected != 0) {
  //     this.ValidVaccineFirstDFose = true;
  //     //   this.PageIsvalid = true;
  //   }
  //   if (
  //     this.VaccinationDetail.secondDoseDatev != "" &&
  //     new Date(this.VaccinationDetail.firstDoseDatev) >
  //       new Date(this.VaccinationDetail.secondDoseDatev)
  //   ) {
  //     this.VaccinationDetail.secondDoseDatev = "";
  //   }
  //   if (
  //     this.VaccinationDetail.boosterDoseDate != "" &&
  //     new Date(this.VaccinationDetail.firstDoseDatev) >
  //       new Date(this.VaccinationDetail.boosterDoseDate)
  //   ) {
  //     this.VaccinationDetail.boosterDoseDate = "";
  //   }
  // }
  // SecondDoseSelected() {
  //   if (this.VaccinationDetail.SecondDoseSelected != 0) {
  //     this.ValidVaccineSecondtDFose = true;
  //     // this.PageIsvalid = true;
  //   }
  //   if (
  //     this.VaccinationDetail.firstDoseDatev != "" &&
  //     new Date(this.VaccinationDetail.firstDoseDatev) >
  //       new Date(this.VaccinationDetail.secondDoseDatev)
  //   ) {
  //     this.VaccinationDetail.firstDoseDatev = "";
  //   }
  //   if (
  //     this.VaccinationDetail.boosterDoseDate != "" &&
  //     new Date(this.VaccinationDetail.secondDoseDatev) >
  //       new Date(this.VaccinationDetail.boosterDoseDate)
  //   ) {
  //     this.VaccinationDetail.boosterDoseDate = "";
  //   }
  // }
  // BoosterDoseSelected() {
  //   if (this.VaccinationDetail.boosterDoseDate != 0) {
  //     this.Validboosterdosedate = true;
  //     // this.PageIsvalid = true;
  //   }
  //   if (
  //     this.VaccinationDetail.firstDoseDate != "" &&
  //     new Date(this.VaccinationDetail.firstDoseDate) >
  //       new Date(this.VaccinationDetail.boosterDoseDate)
  //   ) {
  //     this.VaccinationDetail.firstDoseDate = "";
  //   }
  //   if (
  //     this.VaccinationDetail.secondDoseDatev != "" &&
  //     new Date(this.VaccinationDetail.secondDoseDatev) >
  //       new Date(this.VaccinationDetail.boosterDoseDate)
  //   ) {
  //     this.VaccinationDetail.secondDoseDatev = "";
  //   }
  // }
  // datePositiveTested() {
  //   if (
  //     this.VaccinationDetail.dateNegativeTested != "" &&
  //     new Date(this.VaccinationDetail.dateNegativeTested) >
  //       new Date(this.VaccinationDetail.datePositiveTested)
  //   ) {
  //     this.VaccinationDetail.dateNegativeTested = "";
  //   }
  // }
  // DateNegativeTested() {
  //   if (
  //     this.VaccinationDetail.datePositiveTested != "" &&
  //     new Date(this.VaccinationDetail.dateNegativeTested) >
  //       new Date(this.VaccinationDetail.datePositiveTested)
  //   ) {
  //     this.VaccinationDetail.dateNegativeTested = "";
  //   }
  // }
  // AntibodyTestStatusSelected(event: any) {
  //   if (event.value === this.Antibodyoptionone) {
  //     this.AntibodyCheckStatus = true;
  //     this.userform.controls["AntibodyLevel"].enable();
  //     this.userform.controls["AntibodyTestVenue"].enable();
  //   } else {
  //     this.AntibodyCheckStatus = false;
  //     this.userform.controls["AntibodyLevel"].disable();
  //     this.userform.controls["AntibodyTestVenue"].disable();
  //     this.VaccinationDetail.antibodyLevel = "";
  //     this.VaccinationDetail.antibodyTestDate = "";
  //     this.VaccinationDetail.antibodyTestVenue = "";
  //   }
  // }
  // InfectionStatus(event: any) {
  //   if (event.value == "") {
  //     this.Activetypetreatment = false;
  //     this.isHospitalised = false;
  //     this.VaccinationDetail.treatmentType = "";
  //     this.VaccinationDetail.hospitalisationDuration = "";
  //     this.VaccinationDetail.datePositiveTested = "";
  //     this.VaccinationDetail.dateNegativeTested = "";
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //     this.VaccinationDetail.hospitalisationVenue = "";
  //   } else if (event.value == this.InfectionStatusoptionthree) {
  //     this.Activetypetreatment = false;
  //     this.isHospitalised = false;
  //     this.VaccinationDetail.treatmentType = this.TypeOfTreatmentnonapplicable;
  //     this.VaccinationDetail.hospitalisationDuration = "";
  //     this.VaccinationDetail.datePositiveTested = "";
  //     this.VaccinationDetail.dateNegativeTested = "";
  //     this.VaccinationDetail.hospitalisationVenue = "";
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //   } else {
  //     this.Activetypetreatment = true;
  //   }
  // }
  // TypeTreatmentSelected(event: any) {
  //   if (event.value === this.TypeOfTreatmenthospitalised) {
  //     this.isHospitalised = true;
  //     this.userform.controls["HospitalisationDays"].enable();
  //     this.userform.controls["HospitlisationVenue"].enable();
  //   } else {
  //     this.isHospitalised = false;
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //   }
  // }
  OnDateSelect() {
    var currentDate = new Date();
    var selectedstartMinutes = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getMinutes();
    var selectedstartHours = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getHours();
    var selectedstartDate = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getDate();
    var selectedstartMonth = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getMonth();
    var selectedstartYear = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getFullYear();

    var newSelectedDate = new Date(
      selectedstartYear,
      selectedstartMonth,
      selectedstartDate,
      selectedstartHours,
      selectedstartMinutes
    );
    var dateAdded = newSelectedDate.setDate(newSelectedDate.getDate() + 5114);
    var newSelectedCurrentDate = new Date(
      selectedstartYear,
      selectedstartMonth,
      selectedstartDate,
      selectedstartHours,
      selectedstartMinutes
    );
    if (newSelectedDate >= currentDate) {
      this.ValidDate = false;
      this.PageIsvalid = false;
      //alert(newSelectedCurrentDate);
    } else {
      this.ValidDate = true;
      this.PageIsvalid = true;
    }
    if (selectedstartDate) {
      if (newSelectedDate > currentDate) {
        this.ValidDOB = false;
        this.PageIsvalid = false;
      } else {
        this.ValidDOB = true;
        this.PageIsvalid = true;
      }
    }
  }

  ValidateWorkExperience(user: any, toDate: Date, fromDate: Date) {
    var selectedToDate = new Date(user);
    for (var i = 0; i < this.experinceDetails.length; i++) {
      console.log(
        i,
        this.experienceToDate >= new Date(this.experinceDetails[i].fromDate)
      );

      // console.log(i,this.experienceToDate <= new Date(this.experinceDetails[i].toDate))
      console.log(
        i,
        this.experienceFromDate >= new Date(this.experinceDetails[i].fromDate)
      );
      //console.log(i,this.experienceFromDate <= new Date(this.experinceDetails[i].toDate))

      if (fromDate <= this.experinceDetails[i].toDate) {
        this.experienceIsValid = false;
      }
      if (
        this.experienceFromDate >=
          new Date(this.experinceDetails[i].fromDate) &&
        (this.experinceDetails[i].fromDate =
          !"" || this.experinceDetails[i].toDate != "")
      ) {
        this.experienceIsValid = false;

        break;
      } else {
        this.experienceIsValid = true;
      }
    }
  }

  // Added by Shweta
  omit_special_char(event) {
    this.ValidPassportNofield = true;
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }
  ValidPassportdate() {
    this.ValidDatePassport = true;
    this.PageIsvalid = true;
  }
  //End

  EnablePassportExpiryDate(value: any) {
    if (
      this.profileDetails.passportNumber != "" &&
      this.profileDetails.passportNumber != null
    ) {
      this.DisabledPassportExpiryDate = false;
    } else {
      this.DisabledPassportExpiryDate = true;
      this.profileDetails.passportExpiryDate = "";
    }
  }
  EnableVisaExpiryDate(value: any) {
    if (this.passportVisaInfoDetails) {
      this.passportVisaInfoDetails[value].visaCountry = "";
      for (var i = 0; i < this.passportVisaInfoDetails.length; i++) {
        if (i == value) {
          if (
            this.passportVisaInfoDetails[i].visaStatus != "" &&
            this.passportVisaInfoDetails[i].visaStatus != null
          ) {
            this.passportVisaInfoDetails[i].visaExpiryDate = false;
          } else {
            this.passportVisaInfoDetails[i].visaExpiryDate = true;
            this.passportVisaInfoDetails[i].visaExpiryDate = "";
            this.passportVisaInfoDetails[i].visaCountry = "";
          }
        }
      }
    }
  }

  close() {
    this.cancel();
  }

  cancel() {
    this.IsErrorMessageforVisa = false;
    this.IsErrorMessageforDuplicateVisa = false;
    this.editProfileDialog = false;
    this.showPreviewButtonFirstCertificate = false;
    this.showPreviewButtonSecondCertificate = false;
    this.seedDataService
      .getLOVByTypeName("BloodGroup")
      .subscribe((bloodGroup: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(bloodGroup),
          "Select Blood Group"
        );
        this.bloodGroup = data;
      });
    this.seedDataService
      .getLOVByTypeName("ZodiacSigns")
      .subscribe((zodiacSign: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(zodiacSign),
          "Select Zodiac Sign"
        );
        this.zodiacSign = data;
      });
    this.seedDataService
      .getLOVByTypeName("Hobbies")
      .subscribe((hobbieslist: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(hobbieslist),
          "Select Hobbies"
        );
        this.hobbieslist = data;
      });
    this.seedDataService
      .getLOVByTypeName("PassingYear")
      .subscribe((passingYear: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(passingYear),
          "Select Passing Year"
        );
        this.passingYear = data;
      });

    this.seedDataService
      .getLOVByTypeName("Vaccination Status")
      .subscribe((vaccinationStatusLOV: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(vaccinationStatusLOV),
          "Select Vaccination Status"
        );

        this.noDoseLOVID = data.filter((obj) => {
          return obj.label === "Not Vaccinated";
        })[0].value;
        this.firstDoseLOVID = data.filter((obj) => {
          return obj.label === "1st Dose Vaccinated";
        })[0].value;
        this.secondDoseLOVID = data.filter((obj) => {
          return obj.label === "2nd Dose Vaccinated";
        })[0].value;
        this.boosterDose = data.filter((obj) => {
          return obj.label === "Fully Vaccinated and Booster Administered";
        })[0].value;

        this.vaccinationStatusLOV = data;
      });

    this.seedDataService
      .getLOVByTypeName("Vaccine Type")
      .subscribe((vaccineNameLOV: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(vaccineNameLOV),
          "Select Vaccine Name"
        );
        this.vaccineTypeLOV = data;
        //  console.log(this.vaccineTypeLOV);
      });

    this.seedDataService
      .getLOVByTypeName("Vaccination Status of the Family")
      .subscribe((FamilyStatusLOV: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(FamilyStatusLOV),
          "Choose Status"
        );
        this.FamilyStatus = data;
      });

    this.seedDataService
      .getLOVByTypeName("Antibody Test Status")
      .subscribe((AntibodyTestStatusLov: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(AntibodyTestStatusLov),
          "Choose Status"
        );
        this.Antibodyoptionone = data.filter((obj) => {
          return obj.label === "I have tested and and have the details with me";
        })[0].value;
        this.Antibodyoptiontwo = data.filter((obj) => {
          return (
            obj.label === "I haven't tested or I don't have the details with me"
          );
        })[0].value;
        this.AntibodyTestStatus = data;
      });

    this.seedDataService
      .getLOVByTypeName("Infection and Recovery Details")
      .subscribe((InfectionRecoveryDetailsLov: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(InfectionRecoveryDetailsLov),
          "Choose Status"
        );
        this.InfectionStatusoptionone = data.filter((obj) => {
          return (
            obj.label === "I was tested postive and I have recovered eventually"
          );
        })[0].value;
        this.InfectionStatusoptiontwo = data.filter((obj) => {
          return (
            obj.label === "I was never tested positive but I had few symptoms"
          );
        })[0].value;
        this.InfectionStatusoptionthree = data.filter((obj) => {
          return (
            obj.label ===
            "I was never tested positive and I never had any symptoms"
          );
        })[0].value;
        this.InfectionRecoveryDetails = data;
      });

    this.seedDataService
      .getLOVByTypeName("Type of Treatment")
      .subscribe((TypeTreatmentLov: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(TypeTreatmentLov),
          "Choose Status"
        );
        this.TypeOfTreatmenthospitalised = data.filter((obj) => {
          return obj.label === "I was hospitalised";
        })[0].value;
        this.TypeOfTreatmentooutpatient = data.filter((obj) => {
          return obj.label === "I was an outpatient";
        })[0].value;
        this.TypeOfTreatmentnonapplicable = data.filter((obj) => {
          return obj.label === "Not applicable";
        })[0].value;
        this.TypeOfTreatmentquarintine = data.filter((obj) => {
          return obj.label === "I was home quarantined";
        })[0].value;
        this.TypeTreatment = data;
      });

    //var role = JSON.parse(window.localStorage.getItem('currentUser'));
    //this.UserId = role.UserId;
    this.GetUserPhotoUrl(this.UserId);
    this.profiledataservice
      .GetTeamMemberProfile(this.UserId)
      .subscribe((profile: any) => {
        this.profileDetails = profile;
        if (this.profileDetails.passportNumber != "") {
          this.ValidDatePassportReq = false;
        }
        this.seedDataService
          .getLOVByTypeName("MaritalStatus")
          .subscribe((maritaStatusList) => {
            this.maritalStatusList = maritaStatusList;
            this.seedDataService
              .GetKeyValue("SingleMaritalStatus")
              .subscribe((name) => {
                this.SingleMaritalStatusName = name;
                let tempStatusName = this.SingleMaritalStatusName;
                let filteredList = this.maritalStatusList.filter(function (
                  elem: any
                ) {
                  return (
                    elem.name.trim().toUpperCase() ==
                    tempStatusName.trim().toUpperCase()
                  );
                });
                if (filteredList != null && filteredList.length > 0) {
                  this.SingleMaritalStatusID = filteredList[0].id;
                }
                if (
                  this.SingleMaritalStatusID ==
                  this.profileDetails.maritalStatus
                ) {
                  this.DisableAnniversaryDate = true;
                } else {
                  this.DisableAnniversaryDate = true;
                }
              });
          });
        if (
          this.profileDetails.dateofJoining != null &&
          this.profileDetails.dateofJoining != ""
        ) {
          this.maxDate = new Date(this.profileDetails.dateofJoining.toString());
        } else {
          this.maxDate = new Date();
        }
        this.minDate = new Date(1950, 1, 1);
      });
    this.seedDataService
      .getLOVByTypeName("DependentRelationship")
      .subscribe((dependentRelationships: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(dependentRelationships),
          "Select Relationship"
        );
        this.dependentRelationships = data;
      });
    this.seedDataService
      .getLOVByTypeName("TravelCountryVisited")
      .subscribe((visaCountry: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(visaCountry),
          "Select Country"
        );
        this.visaCountry = data;
      });
  }

  toggleEditDialog() {
   
    this.shown = false;
    $(".mdlProfileContent .tab-pane").removeClass("active");
    $(".mdlProfileMenu li").removeClass("active");
    $(".mdlProfileMenu li:first").addClass("active");
    $("#basic").addClass("active");
    $("#basic").addClass("active");
    this.profiledataservice.GetUserExperience(this.UserId).subscribe((data) => {
      this.experinceDetails = data;
      console.log("experinceDetails" + this.experinceDetails);
    });
    this.profiledataservice.Getdependent(this.UserId).subscribe((data) => {
      this.dependentDetails = data;
      this.refdate = "?" + new Date();
    });
    this.profiledataservice.GetPassportVisa(this.UserId).subscribe((data) => {
      if (data != null) {
        this.shown = true;
      } else {
        this.shown = false;
      }
      this.passportVisaInfoDetails = data;
      this.refdate = "?" + new Date();
    });
    this.profiledataservice.GetTaravelInfo(this.UserId).subscribe((data) => {
      this.travelInfoDetails = data;
      this.refdate = "?" + new Date();
    });
    this.profiledataservice
      .GetSpecialization(this.UserId, "10th")
      .subscribe((data) => {
        this.Specialization1Oth = data;
      });
    this.profiledataservice
      .GetSpecialization(this.UserId, "12th")
      .subscribe((data) => {
        this.Specialization12th = data;
      });
    this.profiledataservice
      .GetSpecialization(this.UserId, "Gradution")
      .subscribe((data) => {
        this.SpecializationGradution = data;
      });
    this.profiledataservice
      .GetSpecialization(this.UserId, "PostGradution")
      .subscribe((data) => {
        this.SpecializationPostGradution = data;
        console.log(
          "SpecializationPostGradution",
          this.SpecializationPostGradution
        );
      });
    this.seedDataService
      .getLOVByTypeName("TravelCountryVisited")
      .subscribe((visaCountry: SelectItem[]) => {
        let data = this.renamePropertyNames(
          JSON.stringify(visaCountry),
          "Select Country"
        );
        this.visaCountry = data;
      });

    // this.profiledataservice
    //   .GetVaccinationDetail(this.UserId)
    //   .subscribe((data) => {
    //     this.VaccinationDetail = data;
    //     console.log("data", data);
    //     console.log("GetVaccinationDetail", this.VaccinationDetail);

    //     //this.setfields(false);
    //    //  this.toggleFields();
    //   });

    this.editProfileDialog = !this.editProfileDialog;
  }
  // setfields(clear: boolean = true) {
  //   if (this.VaccinationDetail.firstDoseDatev != "") {
  //     this.minDatesecond = new Date(this.VaccinationDetail.firstDoseDate);
  //     this.isfirstdose = true;
  //     this.isSeconddose = false;
  //     this.isBoosterdose = false;
  //     if (clear) {
  //       this.VaccinationDetail.secondDoseDatev = "";
  //       this.VaccinationDetail.secondDoseVenue = "";
  //       this.VaccinationDetail.boosterDoseDate = "";
  //       this.VaccinationDetail.boosterDoseVenue = "";
  //     }
  //   }
  //   if (this.VaccinationDetail.secondDoseDatev != "") {
  //     this.isSeconddose = true;
  //     this.isBoosterdose = false;
  //     this.isfirstdose = false;
  //     if (clear) {
  //       this.VaccinationDetail.boosterDoseDate = "";
  //       this.VaccinationDetail.boosterDoseVenue = "";
  //     }
  //   }
  //   if (this.VaccinationDetail.boosterDoseDate != "") {
  //     this.isBoosterdose = true;
  //   }
  //   if (
  //     this.VaccinationDetail.certificateExtension != "" &&
  //     this.VaccinationDetail.certificateExtension != null
  //   ) {
  //     this.showPreviewButtonFirstCertificate = true;
  //     this.HasFirstCertificateUploaded = true;
  //   } else {
  //     this.showPreviewButtonFirstCertificate = false;
  //     this.HasFirstCertificateUploaded = false;
  //   }
  //   if (this.VaccinationDetail.antibodyStatus === this.Antibodyoptionone) {
  //     this.AntibodyCheckStatus = true;
  //     this.userform.controls["AntibodyLevel"].enable();
  //     this.userform.controls["AntibodyTestVenue"].enable();
  //   } else {
  //     this.AntibodyCheckStatus = false;
  //     this.userform.controls["AntibodyLevel"].disable();
  //     this.userform.controls["AntibodyTestVenue"].disable();
  //     this.VaccinationDetail.antibodyLevel = "";
  //     this.VaccinationDetail.antibodyTestDate = "";
  //     this.VaccinationDetail.antibodyTestVenue = "";
  //   }
  //   if (this.VaccinationDetail.infectionStatus == "") {
  //     this.Activetypetreatment = false;
  //     this.isHospitalised = false;
  //     this.VaccinationDetail.treatmentType = "";
  //     this.VaccinationDetail.hospitalisationDuration = "";
  //     this.VaccinationDetail.datePositiveTested = "";
  //     this.VaccinationDetail.dateNegativeTested = "";
  //     this.VaccinationDetail.hospitalisationVenue = "";
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //   } else if (
  //     this.VaccinationDetail.infectionStatus == this.InfectionStatusoptionthree
  //   ) {
  //     this.Activetypetreatment = false;
  //     this.isHospitalised = false;
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //     this.VaccinationDetail.treatmentType = this.TypeOfTreatmentnonapplicable;
  //     this.VaccinationDetail.hospitalisationDuration = "";
  //     this.VaccinationDetail.datePositiveTested = "";
  //     this.VaccinationDetail.dateNegativeTested = "";
  //     this.VaccinationDetail.hospitalisationVenue = "";
  //   } else {
  //     this.Activetypetreatment = true;
  //     this.datenegativetested = new Date(
  //       this.VaccinationDetail.datePositiveTested
  //     );
  //   }
  //   if (
  //     this.VaccinationDetail.treatmentType === this.TypeOfTreatmenthospitalised
  //   ) {
  //     this.isHospitalised = true;
  //     this.userform.controls["HospitalisationDays"].enable();
  //     this.userform.controls["HospitlisationVenue"].enable();
  //   } else {
  //     this.isHospitalised = false;
  //     this.userform.controls["HospitalisationDays"].disable();
  //     this.userform.controls["HospitlisationVenue"].disable();
  //   }
  // }
  // validateVaccinationform() {
  //   this.isformvalid = true;
  //   if (
  //     this.VaccinationDetail.vaccinationStatus == "" ||
  //     this.VaccinationDetail.vaccinationStatus == undefined
  //   ) {
  //     this.ValidVaccinationStatus = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else if (this.VaccinationDetail.vaccinationStatus == this.noDoseLOVID) {
  //     this.checkuniqueInfo(false);
  //     this.checkDosesValidation(false, false, false);
  //   } else if (this.VaccinationDetail.vaccinationStatus != this.noDoseLOVID) {
  //     this.checkuniqueInfo(true);

  //     if (this.VaccinationDetail.vaccinationStatus == this.firstDoseLOVID) {
  //       this.checkDosesValidation(true, false, false);
  //     }
  //     if (this.VaccinationDetail.vaccinationStatus == this.secondDoseLOVID) {
  //       this.checkDosesValidation(true, true, false);
  //     }
  //     if (this.VaccinationDetail.vaccinationStatus == this.boosterDose) {
  //       this.checkDosesValidation(true, true, true);
  //     }
  //   }
  //   if (this.VaccinationDetail.antibodyStatus === 0) {
  //     this.ValidAntibodyTestStatus = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else if (
  //     this.VaccinationDetail.antibodyStatus === this.Antibodyoptionone
  //   ) {
  //     if (this.VaccinationDetail.antibodyLevel == "") {
  //       this.ValidAntibodyLevel = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValidAntibodyLevel = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (this.VaccinationDetail.antibodyTestDate == "") {
  //       this.ValidantibodyTestDate = false;
  //       this.isformvalid = false;
  //       this.PageIsvalid = false;
  //     } else {
  //       this.ValidantibodyTestDate = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (this.VaccinationDetail.antibodyTestVenue == "") {
  //       this.ValidAntibodyTestVenue = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValidAntibodyTestVenue = true;
  //       this.PageIsvalid = true;
  //     }
  //   } else {
  //     this.ValidAntibodyTestStatus = true;
  //     this.PageIsvalid = true;
  //     this.ValidAntibodyLevel = true;
  //     this.ValidantibodyTestDate = true;
  //     this.ValidAntibodyTestVenue = true;
  //   }
  //   if (this.VaccinationDetail.infectionStatus == 0) {
  //     this.ValidInfectionRecoveryDetails = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else if (
  //     this.VaccinationDetail.infectionStatus == this.InfectionStatusoptionone ||
  //     this.VaccinationDetail.infectionStatus == this.InfectionStatusoptiontwo
  //   ) {
  //     this.ValidInfectionRecoveryDetails = true;
  //     if (this.VaccinationDetail.treatmentType == "") {
  //       this.ValidtreatmentType = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValidtreatmentType = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (this.VaccinationDetail.datePositiveTested == "") {
  //       this.ValiddatePositiveTested = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValiddatePositiveTested = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (this.VaccinationDetail.dateNegativeTested == "") {
  //       this.ValiddateNegativeTested = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValiddateNegativeTested = true;
  //       this.PageIsvalid = true;
  //     }
  //   } else {
  //     this.ValidInfectionRecoveryDetails = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (
  //     this.VaccinationDetail.treatmentType == "" &&
  //     this.VaccinationDetail.infectionStatus != 0
  //   ) {
  //     this.ValidtreatmentType = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else if (
  //     this.VaccinationDetail.treatmentType === this.TypeOfTreatmenthospitalised
  //   ) {
  //     if (this.VaccinationDetail.treatmentType == "") {
  //       this.ValidtreatmentType = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValidtreatmentType = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (
  //       this.VaccinationDetail.hospitalisationDuration == "" ||
  //       this.VaccinationDetail.hospitalisationDuration == 0
  //     ) {
  //       this.ValiddhospitalisationDuration = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValiddhospitalisationDuration = true;
  //       this.PageIsvalid = true;
  //     }
  //     if (this.VaccinationDetail.hospitalisationVenue == "") {
  //       this.ValidhospitalisationVenue = false;
  //       this.PageIsvalid = false;
  //       this.isformvalid = false;
  //     } else {
  //       this.ValidhospitalisationVenue = true;
  //       this.PageIsvalid = true;
  //     }
  //   } else {
  //     this.ValidtreatmentType = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.isformvalid) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  // checkuniqueInfo(checkvalidator: boolean) {
  //   if (
  //     (this.VaccinationDetail.vaccine == 0 ||
  //       this.VaccinationDetail.vaccine == null) &&
  //     checkvalidator
  //   ) {
  //     this.ValidVaccinationNameReq = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.ValidVaccinationNameReq = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.VaccinationDetail.beneficiaryReferenceID == "" && checkvalidator) {
  //     this.ValidVaccinationBeneficiaryRef = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.ValidVaccinationBeneficiaryRef = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.VaccinationDetail.uniqueHealthID == "" && checkvalidator) {
  //     this.ValidVaccinationUniqueID = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.ValidVaccinationUniqueID = true;
  //     this.PageIsvalid = true;
  //   }
  // }
  // checkDosesValidation(first: boolean, second: boolean, booster: boolean) {
  //   if (
  //     this.HasFirstCertificateUploaded == undefined &&
  //     first &&
  //     this.VaccinationDetail.certificateExtension != ""
  //   ) {
  //     this.ValidFirstCertificateUploaded = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   }
  //   if (this.VaccinationDetail.firstDoseDatev == "" && first) {
  //     this.ValidVaccineFirstDFose = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.ValidVaccineFirstDFose = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.VaccinationDetail.firstDoseVenue == "" && first) {
  //     this.Validfirstdosevenue = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.Validfirstdosevenue = true;
  //     this.PageIsvalid = true;
  //   }

  //   if (this.VaccinationDetail.secondDoseDatev == "" && second) {
  //     this.ValidVaccineSecondtDFose = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.ValidVaccineSecondtDFose = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.VaccinationDetail.secondDoseVenue == "" && second) {
  //     this.Validseconddosevenue = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.Validseconddosevenue = true;
  //     this.PageIsvalid = true;
  //   }

  //   if (this.VaccinationDetail.boosterDoseDate == "" && booster) {
  //     this.Validboosterdosedate = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.Validboosterdosedate = true;
  //     this.PageIsvalid = true;
  //   }
  //   if (this.VaccinationDetail.boosterDoseVenue == "" && booster) {
  //     this.Validboosterdosevenue = false;
  //     this.PageIsvalid = false;
  //     this.isformvalid = false;
  //   } else {
  //     this.Validboosterdosevenue = true;
  //     this.PageIsvalid = true;
  //   }
  // }
  renamePropertyNames(json: any, _firstOption: any) {
    var obj = JSON.parse(json);

    if (obj != null && obj != undefined && obj != "") {
      var objddl = [];

      objddl.push({ label: _firstOption, value: "" });

      for (var i = 0; i < obj.length; i++) {
        if (obj[i].hasOwnProperty("name")) {
          //objddl[i]["label"] = obj[i - 1]["name"];
          //objddl[i]["value"] = obj[i - 1]["name"];
          //delete obj[i - 1]["name"];
          objddl.push({ label: obj[i]["name"], value: obj[i]["id"] });
        }
      }
    }
    return objddl;
  }

  createDateAsUTC(date: any) {
    var currDate = new Date(date);
    return new Date(
      Date.UTC(
        currDate.getFullYear(),
        currDate.getMonth(),
        currDate.getDate(),
        currDate.getHours(),
        currDate.getMinutes(),
        currDate.getSeconds()
      )
    );
  }

  convert(str: any) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join("/");
  }

  onSubmit(value: string) {
    debugger;
    this.IsErrorMessageforVisa = false;
    for (var i = 0; i < this.passportVisaInfoDetails.length; i++) {
      if (
        (this.passportVisaInfoDetails[i].visaStatus != null &&
          (this.passportVisaInfoDetails[i].visaExpiryDate == "" ||
            this.passportVisaInfoDetails[i].visaExpiryDate == null ||
            this.passportVisaInfoDetails[i].visaCountry == "" ||
            this.passportVisaInfoDetails[i].visaCountry == null)) ||
        (this.passportVisaInfoDetails[i].visaExpiryDate != null &&
          (this.passportVisaInfoDetails[i].visaStatus == "" ||
            this.passportVisaInfoDetails[i].visaStatus == null ||
            this.passportVisaInfoDetails[i].visaCountry == "" ||
            this.passportVisaInfoDetails[i].visaCountry == null)) ||
        (this.passportVisaInfoDetails[i].visaCountry != null &&
          (this.passportVisaInfoDetails[i].visaStatus == "" ||
            this.passportVisaInfoDetails[i].visaStatus == null ||
            this.passportVisaInfoDetails[i].visaExpiryDate == "" ||
            this.passportVisaInfoDetails[i].visaExpiryDate == null))
      ) {
        this.IsErrorMessageforVisa = true;
        this.PageIsvalid = false;
      }
      if (!this.IsErrorMessageforVisa) {
        this.PageIsvalid = true;
      }
    }
    this.IsErrorMessageforDuplicateVisa = false;
    for (var i = 0; i < this.passportVisaInfoDetails.length; i++) {
      for (var j = 0; j < this.passportVisaInfoDetails.length; j++) {
        if (i != j) {
          if (
            this.passportVisaInfoDetails[i].visaStatus ==
              this.passportVisaInfoDetails[j].visaStatus &&
            this.passportVisaInfoDetails[i].visaCountry ==
              this.passportVisaInfoDetails[j].visaCountry &&
            new Date(
              this.passportVisaInfoDetails[i].visaExpiryDate
            ).getDate() ==
              new Date(
                this.passportVisaInfoDetails[j].visaExpiryDate
              ).getDate() &&
            new Date(
              this.passportVisaInfoDetails[i].visaExpiryDate
            ).getMonth() ==
              new Date(
                this.passportVisaInfoDetails[j].visaExpiryDate
              ).getMonth() &&
            new Date(
              this.passportVisaInfoDetails[i].visaExpiryDate
            ).getFullYear() ==
              new Date(
                this.passportVisaInfoDetails[j].visaExpiryDate
              ).getFullYear()
          ) {
            this.IsErrorMessageforDuplicateVisa = true;
            this.PageIsvalid = false;
          }
        }
      }
    }

    //this.ValidateWorkExperience(value);
    if (
      this.profileDetails.passportNumber != null &&
      this.profileDetails.passportExpiryDate == "" &&
      this.profileDetails.passportNumber != ""
    ) {
      this.ValidDatePassport = false;
      this.PageIsvalid = false;
    }
    if (
      (this.profileDetails.passportNumber == null ||
        this.profileDetails.passportNumber == "") &&
      this.profileDetails.passportExpiryDate != ""
    ) {
      this.ValidPassportNofield = false;
      this.PageIsvalid = false;
    }
    if (
      !this.ValidDatePassportReq &&
      (this.profileDetails.passportNumber == null ||
        this.profileDetails.passportNumber == "")
    ) {
      this.PageIsvalid = false;

      this.ValidDatePassportReqerror = false;
    } else {
      this.ValidDatePassportReqerror = true;
    }
    // this.isVaccinationFormValid = this.validateVaccinationform();

    if ( 

       this.ValidPassingYearEqualBirth10th &&
      this.ValidPassingYear10th 
      &&
      this.PageIsvalid &&
    
    // this.isVaccinationFormValid &&
      //this.isformvalid  &&
      this.PageIsvalidSpecialization1Oth &&
      this.PageIsvalidpercentage12th &&
      this.PageIsvalidpostGraduationPercentage &&
      this.PageIsvalidgraduationPercentage &&
      this.experienceIsValid &&
      this.dateValidation
    ) {
      if (
        this.profileDetails.celebratedDateOfBirth != undefined &&
        this.profileDetails.celebratedDateOfBirth != ""
      ) {
        this.profileDetails.celebratedDateOfBirth = this.createDateAsUTC(
          this.profileDetails.celebratedDateOfBirth
        );
      }
      if (
        this.profileDetails.anniversaryDate != undefined &&
        this.profileDetails.anniversaryDate != ""
      ) {
        this.profileDetails.anniversaryDate = this.createDateAsUTC(
          this.profileDetails.anniversaryDate
        );
      }
      if (
        this.profileDetails.passportExpiryDate != undefined &&
        this.profileDetails.passportExpiryDate != ""
      ) {
        this.profileDetails.passportExpiryDate = this.createDateAsUTC(
          this.profileDetails.passportExpiryDate
        );
      }
      if (
        this.profileDetails.visaExpiryDate != undefined &&
        this.profileDetails.visaExpiryDate != ""
      ) {
        this.profileDetails.visaExpiryDate = this.createDateAsUTC(
          this.profileDetails.visaExpiryDate
        );
      }
      if (
        this.profileDetails.dependentDateOfBirth != undefined &&
        this.profileDetails.dependentDateOfBirth != ""
      ) {
        this.profileDetails.dependentDateOfBirth = this.createDateAsUTC(
          this.profileDetails.dependentDateOfBirth
        );
      }
      
      this.loading = true;
      //////Save Team Member Basic Info, Personal Info, Travel Info------------------------------------------
      this.profiledataservice
        .UserSave(this.profileDetails)
        .subscribe((data) => {
          //////Save Team Member Work Experience------------------------------------------
          for (var i = 0; i < this.experinceDetails.length; i++) {
            this.experinceDetails[i].userID = this.profileDetails.userID;
            this.experinceDetails[i].fromDate = this.createDateAsUTC(
              this.experinceDetails[i].fromDate
            );
            this.experinceDetails[i].toDate = this.createDateAsUTC(
              this.experinceDetails[i].toDate
            );
          }
          this.profiledataservice
            .SaveUserExperience(this.experinceDetails)
            .subscribe((data) => {
              //////Save Team Member Family Details------------------------------------------
              for (var i = 0; i < this.dependentDetails.length; i++) {
                this.dependentDetails[i].userID = this.profileDetails.userID;
                this.dependentDetails[
                  i
                ].dependentDateOfBirth = this.createDateAsUTC(
                  this.dependentDetails[i].dependentDateOfBirth
                );
              }
              this.profiledataservice
                .Savedependent(this.dependentDetails)
                .subscribe((data) => {
                  //////Save Team Member 10th, 12th, Graduation etc------------------------------------------
                  this.profiledataservice
                    .SaveSpecialization(this.Specialization1Oth)
                    .subscribe((data) => {
                      this.profiledataservice
                        .SaveSpecialization(this.Specialization12th)
                        .subscribe((data) => {
                          this.profiledataservice
                            .SaveSpecialization(this.SpecializationGradution)
                            .subscribe((data) => {
                              this.profiledataservice
                                .SaveSpecialization(
                                  this.SpecializationPostGradution
                                )
                                .subscribe((data) => {
                                  this.profiledataservice
                                    .SaveVaccinationDetail(
                                      this.VaccinationDetail
                                    )
                                    .subscribe((data) => {
                                      this.loading = false;
                                      this.editProfileDialog = !this
                                        .editProfileDialog;
                                      this.msgs = [];
                                      this.msgs.push({
                                        severity: "success",
                                        summary: "",
                                        detail: "Profile updated successfully",
                                      });
                                    });
                                });
                            });
                        });
                    });
                });
            });
          // Added ST save multiple passport/visa details

          for (var i = 0; i < this.passportVisaInfoDetails.length; i++) {
            this.passportVisaInfoDetails[i].userID = this.profileDetails.userID;
            this.passportVisaInfoDetails[
              i
            ].passportExpiryDate = this.createDateAsUTC(
              this.passportVisaInfoDetails[i].passportExpiryDate
            );
            this.passportVisaInfoDetails[
              i
            ].visaExpiryDate = this.createDateAsUTC(
              this.passportVisaInfoDetails[i].visaExpiryDate
            );
          }

          this.profiledataservice
            .SavePassportVisa(this.passportVisaInfoDetails)
            .subscribe((data) => {});
        });
    }
  }
  AddNewJob() {
    this.profiledataservice
      .GetNewUserExperience(this.profileDetails.userID)
      .subscribe((data) => {
        this.experinceDetails.splice(0, 0, data);
      });
  }

  Remove(data: any) {
    this.confirmationService.confirm({
      message: " Are you sure, you want to delete this record?",
      accept: () => {
        data.active = false;
        this.experienceIsValid = true;
        this.zone.run(() => {});
      },
    });
  }

  AddNewDependent() {
    this.profiledataservice
      .GetNewDependent(this.profileDetails.userID)
      .subscribe((data) => {
        this.dependentDetails.splice(0, 0, data);
        this.refdate = "?" + new Date();
        this.zone.run(() => {});
      });
  }

  AddNewPassVisaDetail() {
    this.shown = true;
    this.profiledataservice
      .GetNewPassportVisa(this.profileDetails.userID)
      .subscribe((data) => {
        this.passportVisaInfoDetails.splice(0, 0, data);
        this.refdate = "?" + new Date();
        this.zone.run(() => {});
      });
  }

  RemoveDependent(data: any) {
    this.confirmationService.confirm({
      message: " Are you sure, you want to delete this record?",
      accept: () => {
        data.active = false;
        this.zone.run(() => {});
      },
    });
  }
  RemovePassportVisa(data: any) {
    this.confirmationService.confirm({
      message: " Are you sure, you want to delete this record?",
      accept: () => {
        data.active = false;
        this.zone.run(() => {});
      },
    });
  }
  DeleteImage() {
    this.confirmationService.confirm({
      message: " Are you sure, you want to delete Profile Image?",
      accept: () => {
        this.profiledataservice
          .DeleteImage(this.profileDetails.userID)
          .subscribe((data) => {
            this.userImg = "../../../UserPhoto/" + data + "?" + new Date();
            if (this.userImg.indexOf("male.png") > -1) {
              this.DeleteProfileImage = false;
            } else {
              this.DeleteProfileImage = true;
            }
          });
      },
    });
  }

  /////-------Custom Validations-------/////
  ValidatePercentagegraduationPercentage(SpecializationGradution: any) {
    var PHONE_REGEXP = /^-?\d*\.?\d*$/;
    if (
      !PHONE_REGEXP.test(SpecializationGradution.percentage) ||
      SpecializationGradution.percentage < 0 ||
      SpecializationGradution.percentage > 100 ||
      !isFinite(SpecializationGradution.percentage)
    ) {
      //SpecializationGradution.percentage = "";
      //return false;
      this.ValidgraduationPercentage = false;
      this.PageIsvalidgraduationPercentage = false;
    } else {
      this.ValidgraduationPercentage = true;
      this.PageIsvalidgraduationPercentage = true;
    }
  }

  ValidatePassingYearSpecialization1Oth(event: any) {
    this.currentDate = new Date();
    console.log(event.originalEvent.target.textContent);
    console.log(this.currentDate.getFullYear());

    if (
      event.originalEvent.target.textContent > this.currentDate.getFullYear()
    ) {
      this.ValidPassingYear10th = false;
      this.PageIsvalid = false;
    } else {
      this.ValidPassingYear10th = true;
      this.PageIsvalid = true;
    }

    var selectedstartYear = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getFullYear();
    console.log(selectedstartYear);

    if (event.originalEvent.target.textContent <= selectedstartYear) {
      this.ValidPassingYearEqualBirth10th = false;
      this.PageIsvalid = false;
    } else {
      this.ValidPassingYearEqualBirth10th = true;
      this.PageIsvalid = true;
    }
  }

  ValidatePercentagepercentage12th(SpecializationGradution: any) {
    var PHONE_REGEXP = /^-?\d*\.?\d*$/;
    if (
      !PHONE_REGEXP.test(SpecializationGradution.percentage) ||
      SpecializationGradution.percentage < 0 ||
      SpecializationGradution.percentage > 100 ||
      !isFinite(SpecializationGradution.percentage)
    ) {
      //SpecializationGradution.percentage = "";
      //return false;
      this.Validpercentage12th = false;
      this.PageIsvalidpercentage12th = false;
    } else {
      this.Validpercentage12th = true;
      this.PageIsvalidpercentage12th = true;
    }
  }

  ValidatePercentageSpecialization1Oth(Specialization12th: any) {
    var PHONE_REGEXP = /^-?\d*\.?\d*$/;
    if (
      !PHONE_REGEXP.test(Specialization12th.percentage) ||
      Specialization12th.percentage < 0 ||
      Specialization12th.percentage > 100 ||
      !isFinite(Specialization12th.percentage)
    ) {
      //Specialization12th.percentage = "";
      //return false;
      this.Validpercentage10th = false;
      this.PageIsvalidSpecialization1Oth = false;
    } else {
      this.Validpercentage10th = true;
      this.PageIsvalidSpecialization1Oth = true;
    }
  }

  ValidatePercentagepostGraduationPercentage(Specialization12th: any) {
    var PHONE_REGEXP = /^-?\d*\.?\d*$/;
    if (
      !PHONE_REGEXP.test(Specialization12th.percentage) ||
      Specialization12th.percentage < 0 ||
      Specialization12th.percentage > 100 ||
      !isFinite(Specialization12th.percentage)
    ) {
      //Specialization12th.percentage = "";
      //return false;
      this.ValidpostGraduationPercentage = false;
      this.PageIsvalidpostGraduationPercentage = false;
    } else {
      this.ValidpostGraduationPercentage = true;
      this.PageIsvalidpostGraduationPercentage = true;
    }
  }

  ValidPhone() {
    var PHONE_REGEXP = /^(\+[\d]{1,5}|0)?[6-9]\d{9}$/i;
    if (
      this.profileDetails.mobile.toString().length < 10 ||
      !PHONE_REGEXP.test(this.profileDetails.mobile)
    ) {
      this.ValidMobileNumber = false;
      this.PageIsvalid = false;
    } else {
      this.ValidMobileNumber = true;
      this.PageIsvalid = true;
    }
  }

  ValidDependent(dependentName: any) {
    var REGEXP = /[^a-zA-Z\-\/. ]/i;
    if (REGEXP.test(dependentName)) {
      this.ValidDependentName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidDependentName = true;
      this.PageIsvalid = true;
    }
  }

  ValidCompanyName(CompanyName: any) {
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(CompanyName)) {
      this.ValidPreviousCompanyName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidPreviousCompanyName = true;
      this.PageIsvalid = true;
    }
  }

  ValidJobTitle(CompanyName: any) {
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(CompanyName)) {
      this.ValidJobTitleName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidJobTitleName = true;
      this.PageIsvalid = true;
    }
  }

  ValidExperienceFromDate(fromDate: any, exp: any) {
    var selectedfromDateYear = new Date(fromDate).getFullYear();
    var selectedstartYear = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getFullYear();
    this.experienceFromDate = fromDate;
    this.selectedId = exp.id;
    var selectedID = exp.id;
    console.log(selectedstartYear);
    var expfromDate = fromDate;
    var exptoDate = exp.toDate;
    if (selectedfromDateYear <= selectedstartYear) {
      this.ValidWorkexpFromDate = false;
      this.PageIsvalid = false;
    } else {
      this.ValidWorkexpFromDate = true;
      this.PageIsvalid = true;
      if (
        expfromDate != "" &&
        expfromDate != null &&
        exptoDate != "" &&
        exptoDate != null
      ) {
        exptoDate = new Date(exptoDate);
        for (var i = 0; i < this.experinceDetails.length; i++) {
          console.log(
            "fromdate condition",
            expfromDate >= new Date(this.experinceDetails[i].fromDate)
          );
          console.log(
            "todate condition",
            exptoDate <= new Date(this.experinceDetails[i].toDate)
          );
          //console.log(i,exptoDate>= new Date(this.experinceDetails[i].fromDate)  ,'exptoDate')
          //console.log(i,this.experienceFromDate >= new Date(this.experinceDetails[i].fromDate ),'expfromdate');
          // console.log(i,this.experienceToDate <= new Date(this.experinceDetails[i].toDate))
          console.log(
            (this.createDateAsUTC(exptoDate) <=
              this.createDateAsUTC(new Date(this.experinceDetails[i].toDate)),
            "condition for todate limit error")
          );
          //console.log(i,this.experienceFromDate <= new Date(this.experinceDetails[i].toDate))

          console.log(
            "condition for fromdate check",
            this.createDateAsUTC(expfromDate) >=
              this.createDateAsUTC(new Date(this.experinceDetails[i].fromDate))
          );
          console.log("condition for dates are empty");

          console.log(
            "ToCondition",
            this.createDateAsUTC(exptoDate) <=
              this.createDateAsUTC(new Date(this.experinceDetails[i].toDate)) &&
              exptoDate >= this.experinceDetails[i].fromDate
          );
          console.log(
            "Fromcondition",
            this.createDateAsUTC(expfromDate) >=
              this.createDateAsUTC(
                new Date(this.experinceDetails[i].fromDate)
              ) && expfromDate <= this.experinceDetails[i].toDate
          );

          /*if(this.createDateAsUTC(expfromDate) >= this.createDateAsUTC(new Date (this.experinceDetails[i].fromDate ))
                 || ((this.createDateAsUTC(exptoDate) <= this.createDateAsUTC( new Date(this.experinceDetails[i].toDate)) )))*/
          if (
            (this.createDateAsUTC(expfromDate) <
              this.createDateAsUTC(this.experinceDetails[i].fromDate) &&
              this.createDateAsUTC(this.experinceDetails[i].fromDate) <
                this.createDateAsUTC(exptoDate)) ||
            (this.createDateAsUTC(expfromDate) <
              this.createDateAsUTC(this.experinceDetails[i].toDate) &&
              this.createDateAsUTC(this.experinceDetails[i].toDate) <
                this.createDateAsUTC(exptoDate)) ||
            (this.createDateAsUTC(this.experinceDetails[i].fromDate) <
              this.createDateAsUTC(expfromDate) &&
              this.createDateAsUTC(exptoDate) <
                this.createDateAsUTC(this.experinceDetails[i].toDate))
          ) {
            if (selectedID != this.experinceDetails[i].id) {
              this.experienceIsValid = false;
              console.log(
                "overlap with ",
                this.experinceDetails[i].CompanyName
              );
              break;
            }
          } else {
            this.experienceIsValid = true;
          }
        }
      }
    }
  }

  ValidExperienceToDate(toDate: any, exp: any, fromDate: any) {
    var selectedToDateYear = new Date(toDate).getFullYear();
    var selectedstartYear = new Date(
      this.profileDetails.celebratedDateOfBirth
    ).getFullYear();
    this.experienceToDate = toDate;
    var experienceFromDate = fromDate;
    console.log(selectedstartYear);
    var expfromDate = exp.fromDate;
    var exptoDate = exp.toDate;
    var selectedID = exp.id;
    if (new Date(this.experienceToDate) <= new Date(fromDate)) {
      this.dateValidation = false;
    } else {
      this.dateValidation = true;
    }
    if (selectedToDateYear <= selectedstartYear) {
      this.ValidWorkexpToDate = false;
      this.PageIsvalid = false;
    } else {
      this.ValidWorkexpToDate = true;
      this.PageIsvalid = true;

      if (
        expfromDate != "" &&
        expfromDate != null &&
        exptoDate != "" &&
        exptoDate != null
      ) {
        for (var i = 0; i < this.experinceDetails.length; i++) {
          //console.log(i,exptoDate >= new Date(this.experinceDetails[i].fromDate) ,'exptodate is greater than fromdate of a company');

          // console.log( i,((this.createDateAsUTC(expfromDate) <= this.createDateAsUTC( new Date(this.experinceDetails[i].expfromDate) && exptoDate >= this.experinceDetails[i].fromDate))),'condition for todate  limit error');
          //console.log(i,expfromDate >= new Date (this.experinceDetails[i].fromDate )|| (exptoDate <= new Date(this.experinceDetails[i].toDate)  &&  exptoDate >= this.experinceDetails[i].fromDate), 'condition for overall error')
          // console.log(i,this.experienceToDate <= new Date(this.experinceDetails[i].toDate))
          // console.log(i,expfromDate >= new Date(this.experinceDetails[i].fromDate) ,'expfromdate is smaller than any company fromdate');
          //console.log(i,this.experienceFromDate <= new Date(this.experinceDetails[i].toDate))

          console.log(
            "fromdate condition",
            expfromDate >= new Date(this.experinceDetails[i].fromDate)
          );

          console.log(
            "todate condition",
            exptoDate <= new Date(this.experinceDetails[i].toDate)
          );
          /*if(this.createDateAsUTC(expfromDate) >= this.createDateAsUTC(new Date (this.experinceDetails[i].fromDate.getDate() ))
                   && ((this.createDateAsUTC(exptoDate) <= this.createDateAsUTC( new Date(this.experinceDetails[i].toDate).getDate()) ))
                   || (this.createDateAsUTC(expfromDate) >= this.createDateAsUTC(new Date(this.experinceDetails[i].fromDate).getDate())
                         && this.createDateAsUTC(exptoDate) >= this.createDateAsUTC(new Date(this.experinceDetails[i].toDate).getDate()))

                       || this.createDateAsUTC(expfromDate) <= this.createDateAsUTC(new Date(this.experinceDetails[i].toDate).getDate() &&
                           this.createDateAsUTC(exptoDate)  <= this.createDateAsUTC(new Date(this.experinceDetails[i].toDate).getDate())
                       )
                   )*/
          /*if(this.createDateAsUTC(expfromDate) >= this.createDateAsUTC(new Date (this.experinceDetails[i].fromDate).getDate())
                   || ((this.createDateAsUTC(exptoDate) <= this.createDateAsUTC( new Date(this.experinceDetails[i].toDate).getDate())) ))*/
          console.log(this.experinceDetails[i].fromDate);
          console.log(this.createDateAsUTC(this.experinceDetails[i].fromDate));
          console.log(new Date(this.experinceDetails[i].fromDate).getDate());
          if (
            (this.createDateAsUTC(expfromDate) <
              this.createDateAsUTC(this.experinceDetails[i].fromDate) &&
              this.createDateAsUTC(this.experinceDetails[i].fromDate) <
                this.createDateAsUTC(exptoDate)) ||
            (this.createDateAsUTC(expfromDate) <
              this.createDateAsUTC(this.experinceDetails[i].toDate) &&
              this.createDateAsUTC(this.experinceDetails[i].toDate) <
                this.createDateAsUTC(exptoDate)) ||
            (this.createDateAsUTC(this.experinceDetails[i].fromDate) <
              this.createDateAsUTC(expfromDate) &&
              this.createDateAsUTC(exptoDate) <
                this.createDateAsUTC(this.experinceDetails[i].toDate))
          ) {
            if (selectedID != this.experinceDetails[i].id) {
              this.experienceIsValid = false;

              break;
            }
          } else {
            this.experienceIsValid = true;
          }
        }
      }
    }
  }

  ValidDependentDOB(dependentDateOfBirth: any) {
    var currentDate = new Date();
    var selectedstartMinutes = new Date(dependentDateOfBirth).getMinutes();
    var selectedstartHours = new Date(dependentDateOfBirth).getHours();
    var selectedstartDate = new Date(dependentDateOfBirth).getDate();
    var selectedstartMonth = new Date(dependentDateOfBirth).getMonth();
    var selectedstartYear = new Date(dependentDateOfBirth).getFullYear();
    var newSelectedCurrentDate = new Date(
      selectedstartYear,
      selectedstartMonth,
      selectedstartDate,
      selectedstartHours,
      selectedstartMinutes
    );
    if (newSelectedCurrentDate >= currentDate) {
      this.ValidDependentDateOfBirth = false;
      this.PageIsvalid = false;
    } else {
      this.ValidDependentDateOfBirth = true;
      this.PageIsvalid = true;
    }
  }

  ValidBoardName() {
    var boardOrUniversityName = this.Specialization12th.boardOrUniversityName;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(boardOrUniversityName)) {
      this.ValidboardOrUniversityName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidboardOrUniversityName = true;
      this.PageIsvalid = true;
    }
  }

  ValidboardNameFor10th() {
    var boardName10th = this.Specialization1Oth.boardOrUniversityName;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(boardName10th)) {
      this.ValidboardName10th = false;
      this.PageIsvalid = false;
    } else {
      this.ValidboardName10th = true;
      this.PageIsvalid = true;
    }
  }

  ValidNameofSchool12th() {
    var boardName10th = this.Specialization12th.schoolOrCollegeName;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(boardName10th)) {
      this.ValidschoolOrCollegeName12th = false;
      this.PageIsvalid = false;
    } else {
      this.ValidschoolOrCollegeName12th = true;
      this.PageIsvalid = true;
    }
  }

  ValidSpecialization() {
    // var specializationName = this.Specialization12th.specializationName;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(this.Specialization12th.specializationName)) {
      this.ValidSpecializationName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidSpecializationName = true;
      this.PageIsvalid = true;
    }
  }

  ValidnameofSchool10th() {
    // var specializationName = this.Specialization1Oth.schoolOrCollegeName;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(this.Specialization1Oth.schoolOrCollegeName)) {
      this.ValidschoolOrCollegeName = false;
      this.PageIsvalid = false;
    } else {
      this.ValidschoolOrCollegeName = true;
      this.PageIsvalid = true;
    }
  }

  Validplaceofeducation10th() {
    // var specializationName = this.Specialization1Oth.place;
    var REGEXP = /[^a-zA-Z0-9\-\/. ]/i;
    if (REGEXP.test(this.Specialization1Oth.place)) {
      this.Validplace = false;
      this.PageIsvalid = false;
    } else {
      this.Validplace = true;
      this.PageIsvalid = true;
    }
  }

  ValidEmergencyPhone() {
    var PHONE_REGEXP = /^(\+[\d]{1,5}|0)?[7-9]\d{9}$/i;
    if (
      this.profileDetails.emergencyContactNumber.toString().length < 10 ||
      !PHONE_REGEXP.test(this.profileDetails.emergencyContactNumber)
    ) {
      this.ValidEmergencyMobileNumber = false;
      this.PageIsvalid = false;
    } else {
      this.ValidEmergencyMobileNumber = true;
      this.PageIsvalid = true;
    }
  }

  ValidAdhar() {
    if (this.profileDetails.adharNumber.toString().length < 12) {
      this.ValidAdharNumber = false;
      this.PageIsvalid = false;
    } else {
      this.ValidAdharNumber = true;
      this.PageIsvalid = true;
    }
  }

  ValidPersonalEmail() {
    var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    if (!EMAIL_REGEXP.test(this.profileDetails.alternateEmailId.toString())) {
      this.ValidPersonalEmailID = false;
      this.PageIsvalid = false;
    } else {
      this.ValidPersonalEmailID = true;
      this.PageIsvalid = true;
    }
  }

  ValidHobbiesText() {
    var Hobbies_REGEXP = /[-A-Za-z\s]+(,[-A-Za-z\s]+)*/;

    if (!Hobbies_REGEXP.test(this.profileDetails.hobbies.toString())) {
      this.ValidHobbies = false;
      this.PageIsvalid = false;
    } else {
      this.ValidHobbies = true;
      this.PageIsvalid = true;
    }
  }

  ValidPAN() {
    var PAN_REGEXP = /^[a-zA-Z0-9]+$/i;

    if (
      this.profileDetails.pan.toString().length < 10 ||
      !PAN_REGEXP.test(this.profileDetails.pan.toString())
    ) {
      this.ValidPANNo = false;
      this.PageIsvalid = false;
    } else {
      this.ValidPANNo = true;
      this.PageIsvalid = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/TeamMember/Profile.ts